<template>
  <div class="flex items-center font-medium">
    <div
      :class="{
        'text-red-600 transform rotate-180': value.change24h.sign < 0,
        'text-green-600': value.change24h.sign > 0,
        'text-gray-400': value.change24h.sign === 0,
      }"
      class="mr-2"
      style="min-width: 12px;"
    >
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512" v-if="value.change24h.sign !== 0" v-bind:src="'@/assets/image/icon/arrow-up-solid.svg'" v-bind:class="'w-3 h-3'" v-bind:aria-hidden="'true'" v-bind:svg-inline="''" v-bind:role="'presentation'" v-bind:focusable="'false'"><path fill="currentColor" d="M272 480h-96c-13.3 0-24-10.7-24-24V256H48.2c-21.4 0-32.1-25.8-17-41L207 39c9.4-9.4 24.6-9.4 34 0l175.8 176c15.1 15.1 4.4 41-17 41H296v200c0 13.3-10.7 24-24 24z"/></svg>
      <svg aria-hidden="true" data-prefix="fas" data-icon="minus" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512" class="svg-inline--fa fa-minus fa-w-14 fa-3x" v-else="" v-bind:src="'@/assets/image/icon/minus.svg'" v-bind:class="'w-3 h-3'" v-bind:aria-hidden="'true'" v-bind:svg-inline="''" v-bind:role="'presentation'" v-bind:focusable="'false'"><path fill="currentColor" d="M416 208H32c-17.67 0-32 14.33-32 32v32c0 17.67 14.33 32 32 32h384c17.67 0 32-14.33 32-32v-32c0-17.67-14.33-32-32-32z"/></svg>
    </div>
    <div class="relative flex flex-col w-6 h-6 mr-2">
      <div class="relative w-4 h-4">
        <component
          :is="imageComponent.base"
          :src="value.icons.base"
          :text="imageText.base"
          class="absolute z-10 w-full h-full max-w-full max-h-full overflow-hidden border border-white rounded-full"
          @error="catchBaseIconError"
        />
      </div>
      <div class="absolute bottom-0 right-0 w-4 h-4">
        <component
          :is="imageComponent.quote"
          :src="value.icons.quote"
          :text="imageText.quote"
          class="w-4 h-4 max-w-full max-h-full overflow-hidden border border-white rounded-full"
          @error="catchQuoteIconError"
        />
      </div>
    </div>
    <component
      :is="value.permalink ? 'a' : 'div'"
      :href="value.permalink || null"
      class="font-medium text-black coin-page"
    >
      <span>{{ value.name }}</span>
    </component>
  </div>
</template>

<script>
export default {
  name: 'ForexNameCell',
  components: {
    AvatarInitials: () => import('@/components/avatar-initials'),
  },
  props: {
    /**
     * The required cell data.
     * Required values: { name, change24h }
     * Optional values: { permalink }
     */
    value: {
      type: Object,
      required: true,
      validator(value) {
        return 'change24h' in value && 'name' in value
      },
    },
  },
  data: () => ({
    iconError: {
      base: false,
      quote: false,
    },
  }),
  computed: {
    imageComponent() {
      return {
        base: this.iconError.base ? 'AvatarInitials' : 'img',
        quote: this.iconError.quote ? 'AvatarInitials' : 'img',
      }
    },
    imageText() {
      return {
        base: this.value.pairCurrencies[0].charAt(0),
        quote: this.value.pairCurrencies[1].charAt(0),
      }
    },
  },
  methods: {
    catchBaseIconError() {
      this.iconError.base = true
    },
    catchQuoteIconError() {
      this.iconError.quote = true
    },
  },
}
</script>
